import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass([_ctx.iconDynamicDomClasses, "inline-flex first:ml-0 last:mr-0"])
  }, [
    _renderSlot(_ctx.$slots, `${_ctx.iconPosition}Icon`, {}, undefined, true)
  ], 2))
}